<template>
  <div class="c-input-select">
    <input v-click-outside="close" class="value" type="text" :id="btnId" v-if="editable"
           v-model="getValue"
           @click="displayDropdown()" :placeholder="placeholder"/>
    <img src="../../assets/icons/angle-down.svg" class="arrow" :class="{open : showDropdown}"
         @click="toggleDropdown()"/>
    <div class="options" v-if="showDropdown">
      <div class="option" v-for="option in options" :key="option" @click="setOption(option)">
        {{ option }}
      </div>
    </div>
  </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3';

export default {
  name: 'InputSelect',
  mixins: [],
  props: {
    placeholder: {
      required: false,
      default: ''
    },
    value: {
      type: [Number, String],
      default: ''
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    editable: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      showDropdown: false,
      btnId: `btn-input-select${Math.random()}`,
    };
  },

  computed: {
    getValue: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        if (this.editable) {
          this.showDropdown = true;
        }
        this.$emit('update:value', value);
      }
    },
  },

  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },

    displayDropdown() {
      this.showDropdown = true;
    },

    setOption(option) {
      this.showDropdown = false;
      this.$emit('update:value', option);
    },

    close() {
      this.showDropdown = false;
    }
  },

  directives: {
    clickOutside: vClickOutside.directive
  },
};
</script>

<style scoped>
.c-input-select {
  height: 50px;
  line-height: 50px;
  @apply bg-cebeo_blue_faded relative shadow-md
}

.value {
  @apply w-full h-full bg-cebeo_blue_faded pl-10 outline-none uppercase
}

.value::placeholder {
  @apply text-cebeo_gray
}

.arrow {
  @apply absolute right-5 top-5 cursor-pointer
}

.options {
  @apply absolute border w-full bg-white z-50 cursor-pointer
}

.option {
  @apply text-left pl-12 py-1 border-b-2 border-cebeo_blue_faded
}
</style>
